import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useLoadRangeAtTs } from '../range/useLoadRangeAtTs';

export function useJumpStream() {
  const range = useStreamUserDefinedRange();
  const loadStream = useLoadRangeAtTs();

  return (ms: number) => {
    return loadStream(range.from + ms);
  };
}
